import { render, staticRenderFns } from "./DeliverySetup.vue?vue&type=template&id=195b3c24&"
import script from "./DeliverySetup.vue?vue&type=script&lang=js&"
export * from "./DeliverySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports